import Report from './Report.js';

export default Report;